import axios from './common';

const state = {
    certificationBodies: [],
    certificationBodiesQueryParams: {
        description: null,
        limit: 10,
        page: 1,
    },
    currentCertificationBodyItem: null,
    editableCertificationBodyItem: null,
    certificationBodiesLoading: false,
    certificationBodyItemLoading: false,
    certificationBodyApiError: null,
    totalCertificationBodies: 0,
};

const getters = {
    certificationBodies: state => {
        return state.certificationBodies;
    },
    certificationBodiesQueryParams: state => {
        return state.certificationBodiesQueryParams;
    },
    certificationBodiesLoading: state => {
        return state.certificationBodiesLoading;
    },
    currentCertificationBodyItem: state => {
        return state.currentCertificationBodyItem;
    },
    editableCertificationBodyItem: state => {
        return state.editableCertificationBodyItem;
    },
    certificationBodyItemLoading: state => {
        return state.certificationBodyItemLoading;
    },
    certificationBodyApiError: state => {
        return state.certificationBodyApiError;
    },
    totalCertificationBodies: state => {
        return state.totalCertificationBodies;
    },
};

const actions = {
    getCertificationBodies(context) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: 'Loading Awarding Bodies',
        }, {root: true}).then(() => context.commit('setCertificationBodiesLoading', true));

        axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/certification-bodies/`, {
            params: context.state.certificationBodiesQueryParams,
        })
            .then(response => {
                context.dispatch('addNotification', {
                    status: 'success',
                    message: 'Awarding Bodies successfully loaded',
                }, {root: true}).then(function() {
                    context.commit('setCertificationBodiesLoading', false);
                    context.commit('setCertificationBodies', response.data);
                });
            });
    },
    async deleteCertificationBody(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Deleting Awarding Body "${item.name}"`,
        }, {root: true}).then(() => context.commit('setCertificationBodyItemLoading', true));

        try {
            await axios.delete(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/certification-bodies/${item._id}`);
            await context.dispatch('addNotification', {
                status: 'success',
                message: `Successfully deleted Awarding Body "${item.name}"`,
            }, {root: true});
            return true;
        } catch(error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Awarding Body "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Delete failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('setCertificationBodyApiError', error);
                    console.error('certificationBodyApiError', error);
                });
            }
            return false;
        } finally {
            context.commit('setCertificationBodyItemLoading', false);
            await context.dispatch('clearCertificationBodyItems');
            await context.dispatch('getCertificationBodies');
        }
    },
    async getCertificationBody(context, item) {
        context.dispatch('addNotification', {
            status: 'loading',
            message: `Retrieving Awarding Body "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setCertificationBodyItemLoading', true);
            context.commit('setCertificationBodyApiError', null);
        });

        try {
            const response = await axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/certification-bodies/${item._id}`);
            context.commit('setCurrentCertificationBodyItem', response.data);
        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Awarding Body "${item.name}" deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Retrieval failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    console.error('certificationBodyApiError', error);
                });
            }
        } finally {
            context.commit('setCertificationBodyItemLoading', false);
        }
    },
    async editCertificationBody(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Editing Awarding Body "${item.name}"`,
        }, {root: true}).then(function() {
            context.commit('setCertificationBodyItemLoading', true);
            context.commit('setCertificationBodyApiError', null);
        });

        try {
            await axios.put(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/certification-bodies/${item._id}`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Awarding Body "${item.name}" successfully edited `,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Awarding Body "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Edit failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('certificationBodyApiError', error);
                    console.error('certificationBodyApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setCertificationBodyItemLoading', false);
            await context.dispatch('clearCertificationBodyItems');
            await context.dispatch('getCertificationBodies');
        }
    },
    async addCertificationBody(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Adding Awarding Body "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setCertificationBodyItemLoading', true);
            context.commit('setCertificationBodyApiError', null);
        });

        try {

            await axios.post(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/certification-bodies/`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Awarding Body "${item.name}" successfully added`,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response) {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Failed to add Awarding Body "${item.name}", please try again`,
                }, {root: true}).then(() => {
                    context.commit('setCertificationBodyApiError', error.response.data);
                });
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Add failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    context.commit('setCertificationBodyApiError', error);
                    console.error('certificationBodyApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setCertificationBodyItemLoading', false);
            await context.dispatch('getCertificationBodies');
        }
    },
    clearCertificationBodyItems(context) {
        context.commit('setCurrentCertificationBodyItem', null);
        context.commit('setEditableCertificationBodyItem', null);
    },
    clearCertificationBodyApiError(context) {
        context.commit('setCertificationBodyApiError', null);
    },
    setCertificationBodyPaginationOptions(context, options) {
        context.commit('certificationBodyPaginationOptions', options);
    },
    setCertificationBodiesSearch(context, search) {
        context.commit('certificationBodiesSearch', search);
    },
};

const mutations = {
    certificationBodyPaginationOptions(state, options) {
        state.certificationBodiesQueryParams.limit = options.itemsPerPage ?? 10;
        state.certificationBodiesQueryParams.page = options.page ?? 1;
    },
    certificationBodiesSearch(state, search) {
        state.certificationBodiesQueryParams.description = `/${search.trim()}/i`;
    },
    setCertificationBodies(state, responseData) {
        state.certificationBodies = responseData.docs;
        state.totalCertificationBodies = responseData.totalDocs;
    },
    setCurrentCertificationBodyItem(state, item) {
        state.currentCertificationBodyItem = item;
        state.editableCertificationBodyItem = {...item};
    },
    setEditableCertificationBodyItem(state, item) {
        state.editableCertificationBodyItem = item;
    },
    setCertificationBodyItemLoading(state, isLoading) {
        state.certificationBodyItemLoading = isLoading;
    },
    setCertificationBodiesLoading(state, isLoading) {
        state.certificationBodiesLoading = isLoading;
    },
    setCertificationBodyApiError(state, error) {
        state.certificationBodyApiError = error;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
